function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

function apply_validation_rules(context, rules) {
  rules.filter((rule) => rule.invalid).forEach((rule) => {
    context.set_validation_error(rule.field, rule.message);
  });
}

export default {
  clear_validation() {
    this.validation_errors = {};
  },
  validate_current_form() {
    this.clear_validation();
    const validators = new Map([
      ["questions", () => this.validate_question_form()],
      ["sections", () => this.validate_section_form()],
      ["forms", () => this.validate_dynamic_form()],
    ]);
    validators.get(this.active_tab)?.();
    return Object.keys(this.validation_errors).length === 0;
  },
  validate_question_form() {
    const text = normalize(this.question_form.text);
    const number = Number(this.question_form.number);
    const duplicate_text = this.questions.some(question => question.id !== this.editing_id && normalize(question.question) === text);
    const duplicate_number = this.questions.some(question => question.id !== this.editing_id && Number(question.question_number) === number);
    apply_validation_rules(this, [
      { field: "question", invalid: !text, message: "Question text is required." },
      { field: "question_number", invalid: !Number.isInteger(number) || number < 1, message: "Enter a valid question number greater than zero." },
      { field: "question_type", invalid: !this.question_form.type, message: "Select an answer type." },
      { field: "question", invalid: Boolean(text && duplicate_text), message: "This question already exists." },
      { field: "question_number", invalid: Boolean(number && duplicate_number), message: "This question number is already in use." },
      { field: "options", invalid: this.is_multiple_choice() && !this.question_form.options.some(option => normalize(option.text)), message: "Add at least one answer option." },
    ]);
  },
  validate_section_form() {
    const name = normalize(this.section_form.name);
    const duplicate = this.sections.some(section => section.id !== this.editing_id && normalize(section.name) === name);
    apply_validation_rules(this, [
      { field: "section_name", invalid: !name, message: "Section name is required." },
      { field: "section_name", invalid: Boolean(name && duplicate), message: "This section already exists." },
      { field: "section_questions", invalid: !this.editing_id && !this.selected_question_ids.length, message: "Select at least one question for this section." },
    ]);
  },
  validate_dynamic_form() {
    const name = normalize(this.dynamic_form.name);
    const duplicate = this.forms.some(form => form.id !== this.editing_id && normalize(form.name || form.form_name) === name);
    apply_validation_rules(this, [
      { field: "form_name", invalid: !name, message: "Form name is required." },
      { field: "form_name", invalid: Boolean(name && duplicate), message: "This form already exists." },
      { field: "form_sections", invalid: !this.editing_id && !this.selected_section_ids.length, message: "Select at least one section for this form." },
    ]);
  },
  set_validation_error(field, message) {
    Reflect.set(this.validation_errors, field, message);
  },
};
